import { render, staticRenderFns } from "./SurveyRecommendationSection.vue?vue&type=template&id=0a5541c3&"
import script from "./SurveyRecommendationSection.vue?vue&type=script&lang=js&"
export * from "./SurveyRecommendationSection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports